module.exports = __webpack_public_path__ + "static/media/background.ecb2ed1e.webp";